import { SxProps, Theme } from '@mui/material';

export const AccountSummaryLinkToCardFrameSX: SxProps<Theme> = {
	width: { xs: '100%', md: '549px' },
	height: { xs: '99px', md: '76px' },
	backgroundColor: '#FFFFFF',
	border: '1px solid #ECECEC',
	justifyContent: 'space-around',
	flexWrap: 'wrap',
	alignItems: 'center',
	paddingX: '10px',
	borderRadius: '5px',
	paddingY: { xs: '10px', md: '0px' },
	gap: { xs: 1, md: 0 },
};

export const AccountSummaryLinkToCardImgSX = (type: string): SxProps<Theme> => ({
	width: type === 'dpvale' ? '55px' : '53px',
	height: type === 'dpvale' ? '32px' : '20px',
	alignSelf: 'center',
	filter: 'invert(100)',
	objectFit: 'stretch',
});

export const AccountSummaryLinkToCardTitleSX: SxProps<Theme> = {
	color: '#333333',
	fontSize: 'var(--font-size-default)',
	fontWeight: 800,
};

export const AccountSummaryLinkToCardDescriptionSX: SxProps<Theme> = {
	color: '#333333',
	fontSize: 'var(--font-size-small)',
};

export const AccountSummaryLinkToCardButtonSX: SxProps<Theme> = (theme) => ({
	fontSize: 'var(--font-size-default)',
	color: theme.palette.primary.main,
	'&:hover': {
		textDecoration: 'underline',
	},
});
